import { commonModels } from '@gatherstar/models';

export default () => {
        return {
                ...commonModels,
        }
};
